import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { AlertsProvider } from './contexts/AlertsContext';
import { AssetsProvider } from './contexts/AssetsContext';
import LoginPage from './pages/LoginPage';
import ClientDashboard from './pages/client/ClientDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import untitledTheme from './theme/untitledTheme';

// Using Untitled UI theme
// Theme is now imported from untitledTheme.js

function App() {
  return (
    <ThemeProvider theme={untitledTheme}>
      <CssBaseline />
      <AuthProvider>
        <AlertsProvider>
          <AssetsProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              
              {/* Client Routes */}
              <Route path="/client" element={
                <ProtectedRoute allowedRoles={['client']}>
                  <ClientDashboard />
                </ProtectedRoute>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              
              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </AssetsProvider>
        </AlertsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
